<template>
    <div class="is-flex-grow-1">
        <loading :isLoading="isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        :tooltipLabel="
                            $t('msg-campo-busca-n', { n: $t('codigo') + ', ' + $t('produto') })
                        "
                    />
                </div>
                <div class="column is-2 situacao-select">
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :clearable="false"
                        :searchable="false"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div
                    class="column is-3"
                    v-if="!produtosPesquisaMercadoIntegracao && permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalAssociacao = true"
                    >
                        {{ $t('vincular-produto') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assMotivoAtendimentoProdutosPesquisaMercado"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !produtosPesquisaMercadoIntegracao"
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else>
                            <router-link
                                v-if="props.row[f.columnId]"
                                :to="{
                                    name: f.redirectName,
                                    params: {
                                        id: props.row[f.columnId],
                                    },
                                    query: { tela: 'motivo-atendimento', id: $route.params.id },
                                }"
                            >
                                {{ props.row[f.key] }}
                            </router-link>
                            <p v-else>
                                {{ isNull(props.row[f.key]) ? '--' : props.row[f.key] }}
                            </p>
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>

        <b-modal :active.sync="showModalAssociacao">
            <div class="bg">
                <ProdutoNewModal
                    :idMotivoAtendimento="$route.params.id"
                    @fecharModal="fecharModal"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import ProdutoNewModal from '@/components/vendas/motivo-atendimento/modal/ProdutoNewModal.vue';

export default {
    components: {
        ProdutoNewModal,
    },
    data() {
        return {
            produtosPesquisaMercadoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASS_CRM_ATENDIMENTO_ATENDIMENTO_PRODUTO'
            ),
            permissao: {},
            debouncedOnSearch: null,
            isEmpty: false,
            isLoading: false,
            assMotivoAtendimentoProdutosPesquisaMercado: [],
            column: 'codigo',
            order: 'asc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            fields: [
                { key: 'codigo', width: '7.5%', sortable: true, sortFn: null },
                {
                    redirectName: 'ven-produto-edit',
                    columnId: 'id',
                    key: 'produto',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                {
                    redirectName: 'ven-produto-grupo-edit',
                    columnId: 'idGrupo',
                    key: 'grupo',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                {
                    redirectName: 'ven-produto-sub-grupo-edit',
                    columnId: 'idSubGrupo',
                    key: 'subGrupo',
                    width: 120,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'marca', width: null, sortable: true, sortFn: null },
                { key: 'familia', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            showModalAssociacao: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-motivo-atendimento');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-motivo-atendimento' },
            });

            return;
        }

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.$axios
                .get(`assMotivoAtendimentoProduto/${this.$route.params.id}`, {
                    params: {
                        column: this.column,
                        order: this.order,
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        situacao: this.situacao.id,
                        param: this.queryFilter,
                    },
                })
                .then(this.mapItems)
                .then((value) => {
                    this.assMotivoAtendimentoProdutosPesquisaMercado = value;
                    this.isEmpty = this.assMotivoAtendimentoProdutosPesquisaMercado.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar produtos.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            const { data } = body;
            this.pagination.totalRows = data.totalElements;
            return data.content.map((ass) => {
                const { produto } = ass;

                return {
                    codigo: produto.idprodutoerp,
                    idAssMotivoAtendimento: ass.id,
                    id: produto.idproduto,
                    produto: produto.descricao,
                    idGrupo: produto.grupoproduto ? produto.grupoproduto.idgrupoproduto : null,
                    grupo: produto.grupoproduto ? produto.grupoproduto.descricao : null,
                    idSubGrupo: produto.subgrupoproduto
                        ? produto.subgrupoproduto.idsubgrupoproduto
                        : null,
                    subGrupo: produto.subgrupoproduto ? produto.subgrupoproduto.descricao : null,
                    idMarca: produto.idmarca,
                    marca: produto.marca,
                    idFamilia: produto.produtoFamilia ? produto.produtoFamilia.idfamilia : null,
                    familia: produto.produtoFamilia ? produto.produtoFamilia.descricao : null,
                    situacao: ass.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            const message = this.$t(
                row.situacao == 1
                    ? 'msg-confirmacao-desativacao-n'
                    : 'msg-confirmacao-reativacao-n',
                { n: row.produto }
            );
            this.$root.confirm({
                message: message,
                onConfirm: () => this.updateSituacao(row),
                onCancel: () => {},
            });
        },
        updateSituacao(selectedAssMotivoAtendimentoProduto) {
            this.isLoading = true;

            const { idAssMotivoAtendimento, situacao } = selectedAssMotivoAtendimentoProduto;

            const updateRequestBody = {
                id: idAssMotivoAtendimento,
                situacao: Number(!situacao),
            };

            this.$axios
                .post('/assMotivoAtendimentoProduto/update-situacao', updateRequestBody)
                .then((r) => {
                    this.$root.showMessage('success', 'Situação alterada com sucesso!');

                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', 'Não foi possível alterar a situação!');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.situacao-select {
    div {
        height: 40px;
    }
}

.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .situacao-select {
        width: 100%;
        padding-bottom: 0.8rem;
    }

    .botao-acao {
        margin-top: 0;
    }
}
</style>
